import { createSlice } from "@reduxjs/toolkit"
import companyService from "../services/company.service"
import { getSalonSlug } from "../utils/salonHost"

const hostSlug = typeof window !== "undefined" ? getSalonSlug() : null

const initialState = {
  slug: hostSlug,
  id: null,
  name: null,
  status: hostSlug ? "idle" : "none",
  error: null,
}

const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {
    setCompanyLoading: (state) => {
      state.status = "loading"
      state.error = null
    },
    setCompanyReady: (state, action) => {
      state.slug = action.payload.slug
      state.id = action.payload.id
      state.name = action.payload.name
      state.status = "ready"
      state.error = null
    },
    setCompanyError: (state, action) => {
      state.status = "error"
      state.error = action.payload
    },
    clearCompany: (state) => {
      state.slug = null
      state.id = null
      state.name = null
      state.status = "none"
      state.error = null
    },
  },
})

export const { setCompanyLoading, setCompanyReady, setCompanyError, clearCompany } =
  companySlice.actions

export const resolveCompanyFromHost = () => async (dispatch) => {
  const slug = getSalonSlug()
  if (!slug) {
    dispatch(clearCompany())
    return null
  }

  dispatch(setCompanyLoading())
  try {
    const company = await companyService.getCompanyBySlug(slug)
    dispatch(
      setCompanyReady({
        slug,
        id: company.id,
        name: company.name,
      })
    )
    return company
  } catch (error) {
    dispatch(setCompanyError(error?.message || "Company not found"))
    return null
  }
}

export default companySlice.reducer
